import { lazy } from 'react';

export const ActionsRoutes = {
  Actions: lazy(() =>
    import('@/modules/Actions/pages/Actions').then(({ Actions }) => ({
      default: Actions,
    })),
  ),
};
